import {Component, Input, OnDestroy, OnInit, Output, ViewEncapsulation, EventEmitter, ChangeDetectorRef} from '@angular/core';
import {CriminalService} from './Services/criminal.service';
import {MatDialog} from '@angular/material/dialog';
import {GroupSetupComponent} from './Components/dialogs/group-setup/group-setup.component';
import {PresetService} from './Services/preset.service';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {CrimeCategoryModel} from './Models/criminal-model';
import {GroupService} from './Services/groups.service';
import {PresetWarningDialogComponent} from './Components/dialogs/preset-warning-dialog/preset-warning-dialog.component';
import {MasterDisclaimerDialogComponent} from './Components/dialogs/master-disclaimer-dialog/master-disclaimer-dialog.component';
import {ClientService} from '../clients-module/services/client.service';
import {Observable, Subject, Subscription} from 'rxjs';
import {DecisionGridEvictionService} from './Services/decision-grid-eviction.service';
import {DecisionGridBankruptcyService} from './Services/decision-grid-bankruptcy.service';
import { CriminalGridDialogsModule } from './Components/dialogs/criminal-grid-dialogs.module';
import { CriminalGridAcceptanceDisclaimer } from './Models/criminalGridDisclaimerAcceptance';
import { AuthService } from '../services/auth.service';
import { DecisionGridChangeLogService } from './Services/decision-grid-change-log.service';
import { ToastrService } from 'ngx-toastr';
import { PresetModel } from './Models/preset-model';
import { tap } from 'rxjs/internal/operators/tap';


@Component({
  selector: 'app-criminal-grid-index',
  templateUrl: './criminal-grid-index.component.html',
  styleUrls: ['./criminal-grid-index.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class CriminalGridIndexComponent implements OnInit, OnDestroy {

  public form: UntypedFormGroup;
  public allCrimes: CrimeCategoryModel;
  public selectedPreset = new UntypedFormControl('');
  private clientLoadedSubscription: Subscription;
  private settingsFetchSub$: Subscription;
  public loading: boolean = false;
  public resetForm: EventEmitter<any> = new EventEmitter();

  constructor(
    private readonly dialog: MatDialog,
    private readonly groupService: GroupService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly criminalService: CriminalService,
    private readonly decisionGridEvictionService: DecisionGridEvictionService,
    private readonly decisionGridBankruptcyService: DecisionGridBankruptcyService,
    private readonly decisionGridChangeLogService: DecisionGridChangeLogService,
    private readonly clientService: ClientService,
    private readonly authService: AuthService,
    public readonly toast: ToastrService,
    public readonly presetService: PresetService,
    private readonly changes: ChangeDetectorRef) {
  }

  public ngOnInit(): void {
    this.createForm();

    
    if (this.clientService.currentClient != null && this.clientService.currentClient.id != null) {
      // Ok, not sure I did this right..
      this.loadPage();
    } else {

      this.clientLoadedSubscription = this.clientService.clientLoaded.subscribe((r: boolean) => {
        this.loadPage();
      });
    }
  }


  public ngOnDestroy(): void {
    if (this.clientLoadedSubscription) {
      this.clientLoadedSubscription.unsubscribe();
    }
  }

  public loadPage(): void {

    this.groupService.loadGroups(this.clientService.currentClient.id);

    this.settingsFetchSub$ = this.criminalService.getCrimes(this.clientService.currentClient.id).pipe(
      tap((data: CrimeCategoryModel) => {
        this.allCrimes = null;
        this.allCrimes = data;
        this.form.patchValue(data);
      })
    ).subscribe();

    this.decisionGridEvictionService.getEvictionSettings(this.clientService.currentClient.id).subscribe();
    this.decisionGridBankruptcyService.getBankruptcySettings(this.clientService.currentClient.id).subscribe();

    this.loadPresets();

    this.selectedPreset.valueChanges.subscribe((id: PresetModel) => {

      id.clientId = this.clientService.currentClient.id;
      console.log('PRESET ID: ', id);
      const dialogRef = this.dialog.open(PresetWarningDialogComponent, {
        // panelClass: 'app-master-disclaimer-dialog',
        // height: '400px',
        width: '480px',
      });

      dialogRef.afterClosed().subscribe(result => {
        if(result !== null) {
          if(this.settingsFetchSub$) this.settingsFetchSub$.unsubscribe();
          this.loading = true;
          this.toast.info('Applying presets... this may take several minutes.');
          id.persistOverrides = result;
          this.presetService.applyPresets(id).pipe(tap(x => { 
            this.toast.success('Master settings applied!');
            this.settingsFetchSub$ = this.criminalService.getCrimes(this.clientService.currentClient.id).pipe(
              tap((data: CrimeCategoryModel) => {
                this.allCrimes = null;
                this.resetForm.next('');
                // this.form.reset();
                this.allCrimes = data;
                this.form.patchValue(data);
                this.loading = false;
              })
            ).subscribe();
           },
           e => {
            this.toast.error('Error assigning presets. Please review existing settings.');
            this.loading = false;
           },
           () => {
            
           })).subscribe();
        }
        
      });
    });

    this.showMasterDisclaimer();
  }

  public showMasterDisclaimer(): void {
    const dialogRef = this.dialog.open(MasterDisclaimerDialogComponent, {
      width: '480px',
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'proceed') {
        let disclaim: CriminalGridAcceptanceDisclaimer = new CriminalGridAcceptanceDisclaimer();
        disclaim.userId = this.authService.loggedInUser.id;
        disclaim.clientId = this.clientService.currentClient.id;
        this.decisionGridChangeLogService.saveCrimGridDisclaimer(disclaim).subscribe(res => {

        },
        err => { 
          //this.tabs.select('general');
          this.toast.error('Error saving DG disclaimer.', '', { closeButton: true, disableTimeOut: true });
        },
        () => { });
      } else {
        //RIQ-1993: if the user does not accept TC, route them back to the client stats screen, first tab
        //this.tabs.select('general');
      }
    });
  }

  public createForm() {

    this.form = this.formBuilder.group({
      crimesAgainstPersons: new UntypedFormControl(),
      crimesAgainstProperty: new UntypedFormControl(),
      crimesAgainstSociety: new UntypedFormControl(),
    });
  }

  public loadPresets(): void {
    this.presetService.loadPresets();
  }

  public setupGroup(): void {
    const dialogRef = this.dialog.open(GroupSetupComponent, {
      width: '950px',
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {

      }
    });
  }

  public resetSettings(): void {

    this.resetForm.next(true);
    
  }

}
